import { SearchStatus, ArrowRight2 } from 'iconsax-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { AppRoutes } from '@/constants/appRoutes'
import { selectImpersonationCreditsFromStore } from '@/store/api/Users/Users.selector'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

export const ImpersonationCard = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const impersonationCredits = useSelector(selectImpersonationCreditsFromStore)

  return (
    <div className="flex flex-col gap-5 w-1/2 bg-baseColorHighlight rounded-2xl p-4 max-md:w-full max-lg:w-3/4">
      <div className="flex flex-col gap-1">
        <p className="text-xl font-medium text-neutralColor">
          {t('dashboard.home.impersonationCard.title')}
        </p>
        <p className="text-sm font-normal text-neutralColor60">
          {t('dashboard.home.impersonationCard.description')}
        </p>
      </div>
      <Separator className="bg-neutralColor30 h-[0.5px]" />

      <div className="flex gap-4 items-center justify-between max-md:flex-col">
        <p className="text-sm font-normal text-neutralColor60">
          {t('dashboard.home.impersonationCard.creditsRemaining', {
            total: impersonationCredits,
          })}
        </p>
        <Button
          className="rounded-3xl h-11 text-base font-medium justify-between gap-3 max-md:w-full"
          variant="default"
          onClick={() => {
            navigate(AppRoutes.impersonationConfirmInfo)
          }}
        >
          <SearchStatus size="20" color={SocialMirrorPalette.neutralColor} />
          {t('dashboard.home.impersonationCard.cta')}
          <ArrowRight2 size="20" color={SocialMirrorPalette.neutralColor} />
        </Button>
      </div>
    </div>
  )
}
